var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 108,
    viewBox: "0 0 106 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9077 67.2575L92.23 99.4614L77.23 94.846L71.4608 106.384L63.0518 72.7429H69.7392L72.9077 67.2575Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6394 72.7429L32.2302 106.384L26.4609 94.846L11.4609 99.4614L30.7832 67.2575L33.9517 72.7429H40.6394Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8376 33.676L87.633 41.9814L82.8376 50.2868V59.8752L74.5348 64.6706C68.0227 75.9458 70.1938 72.1865 69.7394 72.9735C67.4349 72.9735 62.142 72.9735 60.1509 72.9735L51.8453 77.7691L43.5399 72.9737C41.5532 72.9737 36.2541 72.9737 33.9515 72.9737C33.4966 72.1863 35.6682 75.946 29.1561 64.6708L20.853 59.8755V50.287L16.0576 41.9816L20.853 33.6762V24.0878L29.1561 19.2924L33.9515 10.9893H43.5399L51.8453 6.1937L60.1507 10.9891H69.7392L74.5345 19.2922L82.8374 24.0875L82.8376 33.676Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8454 20.0583C63.9541 20.0583 73.7685 29.8729 73.7685 41.9814C73.7685 54.0899 63.9541 63.9045 51.8454 63.9045C39.737 63.9045 29.9224 54.0899 29.9224 41.9814C29.9224 29.8729 39.737 20.0583 51.8454 20.0583Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6916 10.846C98.2416 10.846 100.307 12.9114 100.307 15.4614C100.307 18.0114 98.2416 20.0768 95.6916 20.0768C93.1416 20.0768 91.0762 18.0114 91.0762 15.4614C91.0762 12.9114 93.1416 10.846 95.6916 10.846Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15302 65.0768C12.3399 65.0768 14.9223 67.6591 14.9223 70.846C14.9223 74.0329 12.3399 76.6152 9.15302 76.6152C5.9661 76.6152 3.38379 74.0329 3.38379 70.846C3.38379 67.6591 5.9661 65.0768 9.15302 65.0768Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8321 33.7822C67.1823 35.1345 67.1823 37.3268 65.8321 38.6791L52.7777 51.7337L47.8808 56.6281L42.9862 51.7337L38.0916 46.8368C37.4154 46.1606 37.0762 45.2745 37.0762 44.3906C37.0762 43.5045 37.4154 42.6183 38.0916 41.9422C39.4439 40.5898 41.6339 40.5898 42.9862 41.9422L47.8808 46.8368L60.9356 33.7822C61.6118 33.106 62.4979 32.7691 63.3839 32.7691C64.2698 32.7691 65.1562 33.106 65.8321 33.7822Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.192 93.9229C104.148 93.9229 104.922 93.148 104.922 92.1922C104.922 91.2363 104.148 90.4614 103.192 90.4614C102.236 90.4614 101.461 91.2363 101.461 92.1922C101.461 93.148 102.236 93.9229 103.192 93.9229Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.576 33.9229C99.5319 33.9229 100.307 33.148 100.307 32.1922C100.307 31.2363 99.5319 30.4614 98.576 30.4614C97.6201 30.4614 96.8452 31.2363 96.8452 32.1922C96.8452 33.148 97.6201 33.9229 98.576 33.9229Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4993 65.0768C91.4552 65.0768 92.2301 64.3019 92.2301 63.346C92.2301 62.3901 91.4552 61.6152 90.4993 61.6152C89.5434 61.6152 88.7686 62.3901 88.7686 63.346C88.7686 64.3019 89.5434 65.0768 90.4993 65.0768Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8069 5.07677C78.7628 5.07677 79.5377 4.30188 79.5377 3.346C79.5377 2.39013 78.7628 1.61523 77.8069 1.61523C76.8511 1.61523 76.0762 2.39013 76.0762 3.346C76.0762 4.30188 76.8511 5.07677 77.8069 5.07677Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7298 97.3845C55.6857 97.3845 56.4606 96.6096 56.4606 95.6537C56.4606 94.6978 55.6857 93.9229 54.7298 93.9229C53.7739 93.9229 52.999 94.6978 52.999 95.6537C52.999 96.6096 53.7739 97.3845 54.7298 97.3845Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9607 9.69216C19.9166 9.69216 20.6915 8.91727 20.6915 7.96139C20.6915 7.00551 19.9166 6.23062 18.9607 6.23062C18.0049 6.23062 17.23 7.00551 17.23 7.96139C17.23 8.91727 18.0049 9.69216 18.9607 9.69216Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6146 54.6922C13.5704 54.6922 14.3453 53.9173 14.3453 52.9614C14.3453 52.0055 13.5704 51.2306 12.6146 51.2306C11.6587 51.2306 10.8838 52.0055 10.8838 52.9614C10.8838 53.9173 11.6587 54.6922 12.6146 54.6922Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11456 91.6152C6.07044 91.6152 6.84533 90.8403 6.84533 89.8845C6.84533 88.9286 6.07044 88.1537 5.11456 88.1537C4.15868 88.1537 3.38379 88.9286 3.38379 89.8845C3.38379 90.8403 4.15868 91.6152 5.11456 91.6152Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80694 36.2306C3.76282 36.2306 4.53771 35.4557 4.53771 34.4998C4.53771 33.544 3.76282 32.7691 2.80694 32.7691C1.85106 32.7691 1.07617 33.544 1.07617 34.4998C1.07617 35.4557 1.85106 36.2306 2.80694 36.2306Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon-11.df2a67add42d8746abe1a6b1f6eee86e.svg";
export { ForwardRef as ReactComponent };